/** A document defect is reported once, to the console, and never to the broadcast. */

export interface SceneReport {
  /** Report `message` the first time `key` is seen and never again. */
  once: (key: string, message: string) => void;
}

function toConsole(message: string): void {
  console.warn("[overlay] scene:", message);
}

export function createSceneReport(sink: (message: string) => void = toConsole): SceneReport {
  const seen = new Set<string>();

  return {
    once: (key, message) => {
      if (seen.has(key)) return;
      seen.add(key);
      sink(message);
    },
  };
}

/** The report every renderer shares, so one bad document costs one console line. */
export const sceneReport = createSceneReport();
